import CityPageSEO from "@/hooks/usePageSEO";
import PeachtreeCityHeroSection from "./components/HeroSection";
import PeachtreeCityStickyNav from "./components/StickyNav";
import PeachtreeCityProcessingTimeSection from "./components/ProcessingTimeSection";
import PeachtreeCityServicesSection from "./components/ServicesSection";
import PeachtreeCityLocalAreaSection from "./components/LocalAreaSection";
import PeachtreeCityTestimonialsSection from "./components/TestimonialsSection";
import PeachtreeCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PeachtreeCityComparisonSection from "./components/ComparisonSection";
import PeachtreeCityMistakesSection from "./components/MistakesSection";
import PeachtreeCityHowItWorksSection from "./components/HowItWorksSection";
import PeachtreeCityFAQSection, { faqs } from "./components/FAQSection";
import PeachtreeCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PeachtreeCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function PeachtreeCityPage() {
  return (
    <div className="font-sans">
      <CityPageSEO config={{
        cityName: "Peachtree City",
        route: "/peachtree-city",
        description: "Emergency and expedited passport services in Peachtree City, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Fayette County and south metro Atlanta travelers. Get your emergency passport fast!",
        geoPlacename: "Peachtree City, Georgia",
        geoPosition: "33.3968;-84.5958",
        keywords: "expedited passport, emergency passport, Peachtree City passport, same day passport Peachtree City, fast passport Georgia, Fayette County passport",
        faqs,
      }} />
      <PeachtreeCityHeroSection />
      <PeachtreeCityStickyNav />
      <PeachtreeCityProcessingTimeSection />
      <PeachtreeCityLocalAreaSection />
      <PeachtreeCityServicesSection />
      <PeachtreeCityTestimonialsSection />
      <PeachtreeCityAcceptanceFacilitiesSection />
      <PeachtreeCityComparisonSection />
      <PeachtreeCityMistakesSection />
      <PeachtreeCityHowItWorksSection />
      <PeachtreeCityFAQSection />
      <PeachtreeCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/peachtree-city" state="GA" />
      <PeachtreeCityFinalCTA />
    </div>
  );
}